export enum LessonLearnSessionStatusEnum {
    Created,
    InProgress,
    Completed,
    Failed,
    Expired,
    Terminated,
    WaitingConfirm,
}
